import { store } from '../app/store';
import { getApiGatewayUrl } from './deviceStatusHandler';
const apigClientFactory = require('aws-api-gateway-client').default;

export interface UpdateDeviceComponentStatusRequest {
    deviceId: string;
    componentId: string;
    vin: string;
    componentType: string;
    status: string;
    notes?: string;
    errorMessage?: string;
}

export interface UpdateDeviceComponentStatusResponse {
    success: boolean;
}

export default (
    request: UpdateDeviceComponentStatusRequest,
    setResult: (success: boolean, result: UpdateDeviceComponentStatusResponse | any) => void,
) => {
    // extract endpoint from config
    const client = apigClientFactory.newClient({
        invokeUrl: getApiGatewayUrl(),
        retries: 3,
    });

    const requestBody = {
        deviceId: request.deviceId,
        vin: request.vin,
        componentId: request.componentId,
        componentType: request.componentType,
        status: request.status,
        ...(request.notes && { notes: request.notes }),
        ...(request.errorMessage && { errorMessage: request.errorMessage }),
    };

    client
        .invokeApi(
            {},
            '/update_device_component_status',
            'POST',
            {
                headers: {
                    Authorization: store.getState().userData.userInfo!.jwt,
                    'Content-Type': 'application/json',
                },
            },
            requestBody,
        )
        .then((response: any) => {
            const unescapedData = response.data.replace(/\\"/g, '"');
            const parsedData = JSON.parse(unescapedData);
            setResult(parsedData.success, parsedData);
        })
        .catch((response: any) => {
            setResult(false, response);
        });
};
